import { useEffect } from 'react';

// eslint-disable-next-line import/no-anonymous-default-export
export default (ref, handler) => {
    useEffect(
        () => {
            const listener = (event) => {
                if (!ref.current || ref.current.contains(event.target)) {
                    return;
                }
                handler(event);
            };
            document.addEventListener('mouseover', listener);
            return () => {
                document.removeEventListener('mouseout', listener);
            };
        },
        [ref, handler],
    );
};
